import React from 'react';
import { motion } from 'framer-motion';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';
import Button from 'components/ui/Button';

export default function AlternativesPanel({ alternatives, currentPrice, onSelect }) {
  return (
    <div className="mb-4">
      <h4 className="font-heading font-semibold text-sm text-slate-300 mb-3 flex items-center gap-2">
        <Icon name="Sparkles" size={16} color="#06B6D4" />
        Budget-Friendly Alternatives
      </h4>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1">
        {alternatives?.map((alt, i) => {
          const savings = currentPrice - alt?.price;
          return (
            <motion.div
              key={alt?.id}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.1 }}
              className="flex-shrink-0 w-40 bg-slate-800/80 rounded-xl border border-slate-700 overflow-hidden cursor-pointer hover:border-cyan-500/40 transition-colors"
              onClick={() => onSelect(alt)}
            >
              <div className="h-24 overflow-hidden bg-slate-700">
                <Image src={alt?.image} alt={alt?.imageAlt} className="w-full h-full object-cover" />
              </div>
              <div className="p-2.5">
                <p className="text-xs text-slate-300 font-medium line-clamp-2 mb-1">{alt?.name}</p>
                <div className="flex items-center justify-between">
                  <span className="font-data text-sm font-bold text-cyan-400">${alt?.price?.toFixed(2)}</span>
                  {savings > 0 && (
                    <span className="text-xs text-emerald-400 bg-emerald-400/10 px-1.5 py-0.5 rounded">
                      -${savings?.toFixed(2)}
                    </span>
                  )}
                </div>
                <div className="mt-2">
                  <Button variant="ghost" size="xs" className="w-full text-xs">
                    View
                  </Button>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}